(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-service.js');
'use strict';

const {
  jupiter
} = svs.core;
const {
  logger
} = svs.myProfile;

const getCustomizedsettingsAsync = async () => {
  try {
    var _response$customizedS;
    const path = '/player/2/customizedsettings';
    const {
      response
    } = await jupiter.callAsync({
      method: 'GET',
      path,
      data: {}
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error when fetching player preferences', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      playerCustomizedSettings: (response === null || response === void 0 || (_response$customizedS = response.customizedSettings) === null || _response$customizedS === void 0 ? void 0 : _response$customizedS.properties) || {}
    };
  } catch (err) {
    logger.warn('Error when fetching player preferences', err);
    return {
      error: err,
      playerCustomizedSettings: {}
    };
  }
};
const getCustomerBankAccountsAsync = async () => {
  try {
    const path = '/player/1/bankaccounts';
    const {
      response
    } = await jupiter.callAsync({
      method: 'GET',
      path,
      data: {}
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error when fetching player bankaccounts', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      bankAccount: (response === null || response === void 0 ? void 0 : response.bankAccounts.length) > 0 ? response === null || response === void 0 ? void 0 : response.bankAccounts[0] : response === null || response === void 0 ? void 0 : response.bankAccounts
    };
  } catch (err) {
    logger.warn('Error when fetching player bankaccounts', err);
    return {
      error: err,
      bankAccount: {}
    };
  }
};
const putSendMobileVerificationCodeAsync = async () => {
  try {
    const path = '/player/1/mobile/verification';
    const response = await jupiter.callAsync({
      method: 'PUT',
      path,
      data: {}
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error when trying to verify phone', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (err) {
    logger.warn('Error when trying to verify phone', err);
    return {
      error: err
    };
  }
};

const postEmailAsync = async email => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'POST',
      path: '/player/1/properties/email',
      data: {
        email
      }
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error posting email', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (err) {
    logger.warn('Error posting email', err);
    return {
      error: err
    };
  }
};

const postCellPhoneAsync = async mobile => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'POST',
      path: '/player/1/properties/mobile',
      data: {
        mobile
      }
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error posting mobile', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (err) {
    logger.warn('Error posting mobile', err);
    return {
      error: err
    };
  }
};
const deleteCellPhoneAsync = async () => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'DELETE',
      path: '/player/1/properties/mobile',
      data: {}
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error deleting mobile', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (err) {
    logger.warn('Error deleting mobile', err);
    return {
      error: err
    };
  }
};
const getTranscriptStatus = async () => {
  try {
    var _response$response, _response$response2;
    const response = await jupiter.callAsync({
      method: 'GET',
      path: '/compliance/1/ordercustomertranscriptstatus',
      data: {}
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error fetching transcript status', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 || (_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.error,
      data: (response === null || response === void 0 || (_response$response2 = response.response) === null || _response$response2 === void 0 || (_response$response2 = _response$response2.getOrderCustomerTranscriptStatusReplyObject) === null || _response$response2 === void 0 ? void 0 : _response$response2.ordersstatus) || []
    };
  } catch (error) {
    logger.warn('Error fetching transcript status', error);
    return {
      error,
      data: null
    };
  }
};
const postTranscriptOrdering = async transcriptType => {
  try {
    var _response$response3;
    const response = await jupiter.callAsync({
      path: '/compliance/1/ordercustomertranscript',
      method: 'POST',
      data: {
        transcriptType
      }
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error ordering transcript', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 || (_response$response3 = response.response) === null || _response$response3 === void 0 ? void 0 : _response$response3.error,
      data: response.data || {}
    };
  } catch (error) {
    logger.warn('Error ordering transcript', error);
    return {
      error,
      data: null
    };
  }
};
const putEmailVerifyAsync = async () => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      path: '/player/1/email/verification',
      method: 'PUT',
      data: {}
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error asking for email verification', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (error) {
    logger.warn('Error asking for email verification', error);
    return {
      error
    };
  }
};

const postAliasAsync = async alias => {
  try {
    const {
      response
    } = await jupiter.callAsync({
      method: 'POST',
      path: '/player/1/alias',
      data: {
        alias
      }
    });
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error posting alias', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      aliasAccepted: response === null || response === void 0 ? void 0 : response.aliasAccepted,
      suggestedAlias: response !== null && response !== void 0 && response.suggestedAlias ? response === null || response === void 0 ? void 0 : response.suggestedAlias[0] : null
    };
  } catch (err) {
    logger.warn('Error posting alias', err);
    return {
      error: err
    };
  }
};
svs.myProfile.react.pages.myInformation.myInformationService = {
  getTranscriptStatus,
  getCustomerBankAccountsAsync,
  putSendMobileVerificationCodeAsync,
  postCellPhoneAsync,
  postEmailAsync,
  deleteCellPhoneAsync,
  getCustomizedsettingsAsync,
  postTranscriptOrdering,
  putEmailVerifyAsync,
  postAliasAsync
};

 })(window);